'use es6';

import { fromJS } from 'immutable';
export const defaultWaterfallSeriesOptions = fromJS({
  borderWidth: 0,
  animation: false,
  minPointLength: 2
});